// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationAlertId } from './FermentationAlert';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationAlertAckTokenId = (z.number());
export const fermentationAlertAckToken = z.object({
    id: fermentationAlertAckTokenId,
    token: z.string(),
    alert_id: fermentationAlertId,
    operator_id: operatorId,
    expires_at: z.date(),
    created_at: z.date(),
});
export const fermentationAlertAckTokenInitializer = z.object({
    id: fermentationAlertAckTokenId.optional(),
    token: z.string(),
    alert_id: fermentationAlertId,
    operator_id: operatorId,
    expires_at: z.date(),
    created_at: z.date().optional(),
});
export const fermentationAlertAckTokenMutator = z.object({
    id: fermentationAlertAckTokenId.optional(),
    token: z.string().optional(),
    alert_id: fermentationAlertId.optional(),
    operator_id: operatorId.optional(),
    expires_at: z.date().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=FermentationAlertAckToken.js.map